// import { useUserStore } from "../userStore";

// helpers/cart.js
export function createCartItemPayload(cartId,item, quantity,isFreeItem=false,isAddedItem=false) {
  if(quantity==null|| quantity==undefined) quantity=1;
    const name= ((isFreeItem||isAddedItem)?item.product_code:item.name);
    // alert(item.pv);
    // alert(item.cp_price);
    // console.log(item,'item in helper')
    const pv= ((isFreeItem||isAddedItem)?( item.unitPv?Number(item.unitPv):item.pv ):(Number(item.pv)));
    const product_id= (isFreeItem||isAddedItem)?item.product_code:item.sku;
    // const sku= (isFreeItem||isAddedItem)?item.product_code:item.sku;
    const dp= (isFreeItem||isAddedItem)? Number(item.unitRate):Number(item.dp);
    const price= (isFreeItem||isAddedItem)?Number(item.unitRate):Number(item.price);
    const total_pv = (Number(pv) * Number(quantity)); 
    const base_pv = (Number(pv) / Number(quantity)); 
    // const total_pv = (item.cv ? 0:  (Number(pv) * Number(quantity))); 
    // const base_pv = ((item.cv) ? 0 : (Number(pv) / Number(quantity))); 
    const total= parseInt(Number(dp) * Number(quantity));
    // name: item.product_code,
    // pv: item.unitPv,
    // quantity: item.quantity||1,
    // thumbnail:"",
    // product_id: item.product_code,
    // sku: item.product_code,
    // dp: item.unitRate,
    // price: item.unitRate,
    return {
      id:item.id,
      name:name,
      product_id: product_id,
      dp:dp,
      isFreeItem:isFreeItem,
      isItemAdded:isAddedItem,
      uom:item.uom,
      cart_id: cartId,
      parent_id: 0,
      quantity: Number(quantity),
      total_pv: total_pv,
      base_pv:base_pv,
      base_price: dp,
      mrp:item?.price,
      custom_price:Number(item.cp_price),
      total:total,
      base_total:total,
      weight: 0, // Replace with actual weight
      total_weight: 0,
      base_total_weight: 0,
      price: price,
      pv:pv,
      tax_percent: 0, // Replace with actual tax percent
      tax_amount: 0,
      base_tax_amount: 0,
      discount_percent: 0, // Replace with actual discount percent
      discount_amount: 0,
      base_discount_amount:0,
      tax_category_id:0, // Replace with actual tax category ID
      dis_per_pv:0,
      base_dis_amt_pv:0,
      dis_amt_pv:0,
      offer_code:'',
      cv:false,
      is_cv:(isFreeItem||isAddedItem)?false:true,
      // cv:item.cv,
      is_guest:false,
      is_new_item:true,
      url_key:item?.url_key,
      additional: {
        is_cv:(isFreeItem||isAddedItem)?false:true,
          isFreeItem:isFreeItem,
          isAddedItem:isAddedItem,
        }
    };
  }
// export function createPreloginCartItemPayload()
//   const payload = {
//     is_guest:false,
//     // customer_id:mca_no,
//   dp:item.dp,
//   name:item.name,
//   uom:item.uom,
//   thumbnail:(Array.isArray(item?.images) && item?.images.length>0)?item?.images[0]:item.thumbnail,
//   cart_id: cartId,
//   parent_id: 0,
//   product_id: item.sku,
//   quantity: Number(item.quantity||"1")||1,
//   weight: 0, // Replace with actual weight
//   total_weight: 0,
//   base_total_weight: 0,
//   price: Number(item.dp),
//   pv:Number(item.pv),
//   total_pv: (item.cv?0:(Number(item.pv) * Number(item.quantity))),
//   base_pv:(item.cv?0:(Number(item.pv)/Number(item.quantity))),
//   base_price: Number(item.dp),
//   total:Number(item.dp) * item.quantity,
//   base_total:Number(item.dp) * item.quantity,
//   tax_percent: 0, // Replace with actual tax percent
//   tax_amount: 0,
//   base_tax_amount: 0,
//   discount_percent: 0, // Replace with actual discount percent
//   discount_amount: 0,
//   base_discount_amount:0,
//   tax_category_id:0, // Replace with actual tax category ID
//   dis_per_pv:0,
//   base_dis_amt_pv:0,
//   dis_amt_pv:0,
//   offer_code:'',
//   cv:false,
//   // cv:item?.cv,
//   mrp:item?.price,
//   custom_price:item?.cp_price,
//   additional: {
//     ...product
//   }
// }